import { firestoreAction } from 'vuexfire'
import { Module, VuexModule, Action, getModule } from 'vuex-module-decorators'
import { firestore } from '../firebase'
import { UserStoreMod } from './user-store'
import store from './'
import { Order } from 'foodme-firestore-db'

@Module({ dynamic: true, store, name: 'orders' })
class OrderStore extends VuexModule {
  orders: Array<Order> = []

  @Action
  bindOrders () {
    return (firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        'orders',
        firestore.collection('orders')
          .where('vendorId', '==', UserStoreMod.vendorId),
        { maxRefDepth: 0 }
      )
    }) as Function)(this.context)
  }
}

export const orderStore = getModule(OrderStore)
